import PageTransitionLoading from "@/components/PageTransitionLoading";
import { useDeviceInfoQuery, usePreventContextMenu } from "@/hooks";
import Footer from "@/layouts/footer";
import Header from "@/layouts/Header";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Layout(_ref) {
  var _router$asPath;
  let {
    children,
    noHeader,
    noTransition
  } = _ref;
  usePreventContextMenu();
  const router = useRouter();
  const {
    data: {
      deviceInfo
    } = {}
  } = useDeviceInfoQuery();
  const isTvApp = router === null || router === void 0 || (_router$asPath = router.asPath) === null || _router$asPath === void 0 ? void 0 : _router$asPath.includes("/tvapp/static");
  const visible = !(deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isWebView) && !isTvApp;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageTransitionLoading, {}), visible && /*#__PURE__*/_jsx(Header, {
      noHeader: noHeader,
      noTransition: noTransition
    }), /*#__PURE__*/_jsx("main", {
      id: "main",
      tabIndex: -1,
      children: children
    }), visible && /*#__PURE__*/_jsx(Footer, {})]
  });
}